import { EXPRESS_UI, type ExpressConfirmDialogProps } from '../constants/express'
import { downgradedExpressItems } from '../helpers/express'
import { CheckoutDialog } from './CheckoutDialog'

export function ExpressConfirmDialog({
  confirmation,
  submitting,
  onCancel,
  onConfirm,
}: ExpressConfirmDialogProps) {
  const downgraded = downgradedExpressItems(confirmation.items)

  return (
    <CheckoutDialog
      title={EXPRESS_UI.confirmTitle}
      lead={confirmation.message || EXPRESS_UI.confirmLead}
      cancelLabel={EXPRESS_UI.confirmCancel}
      confirmLabel={EXPRESS_UI.confirmProceed}
      confirming={submitting}
      labelledBy="express-confirm-title"
      describedBy="express-confirm-lead"
      dialogLabel={EXPRESS_UI.dialogLabel}
      closeAria={EXPRESS_UI.closeAria}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      {downgraded.length > 0 ? (
        <ul className="checkout-dialog__items">
          {downgraded.map((item) => (
            <li key={item.variantId}>
              <strong>{item.productName}</strong>
              <small>{item.message}</small>
            </li>
          ))}
        </ul>
      ) : null}
    </CheckoutDialog>
  )
}
